import React from 'react';
import { IconButton } from '@mui/material';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';

const ViewMapTrigger = ({ onOpen }) => {
  return (
    <IconButton size="small" onClick={onOpen}>
      <MapOutlinedIcon fontSize="inherit" />
    </IconButton>
  );
};

export default ViewMapTrigger;
